import React from "react";
import { Data } from "../../../../components/Formatters/DateTime";

const tspsDetalhes = ({ data, row }) => {
  const query = data.result;
  const queryFilter = query.filter((f) => f.sqPessoa === row.data.sqPessoa);

  return (
    <div className="text-left m-4">
      <h6>
        <strong>Vínculo(s)</strong>
      </h6>
      {queryFilter.map((linha) => (
        <p style={{ marginBottom: 0 }}>
          Entrada: <Data value={linha.dtInicio} /> | Saída:{" "}
          {linha.dtFim === "0001-01-01T00:00:00" ? "----" : <Data value={linha.dtFim} />}
        </p>
      ))}
    </div>
  );
};

export default tspsDetalhes;
